<template>
	<ul :id="listId" class="evaluation-questions-section--row__questions tw-text-app-color-font">
		<li
			:key="keyRender + index"
			v-for="(question, index) in questions"
			class="tw-flex tw-gap-4 tw-items-center tw-justify-between tw-px-2 tw-py-4"
		>
			<p-drag-handle class="sort-handler"></p-drag-handle>
			<div>{{ index + 1 }}.</div>
			<div class="tw-flex-auto">
				{{ propOr('-', questionsType.key, question) }}
			</div>
			<close-icon
				style="width: 20px"
				class="cursor-pointer"
				@click="$emit('removeClicked', question)"
			></close-icon>
		</li>
	</ul>
</template>
<script>
import { move, pathOr, propOr } from 'ramda';
import Sortable from 'sortablejs';
import CloseIcon from '../../../../shared/components/icons/close-icon';
import PDragHandle from '../../../../shared/components/ui/p-drag-handler';
import { genId } from '../../../../shared/utils/uuid';

export default {
	components: { PDragHandle, CloseIcon },
	name: 'evaluation-question-sortable-list',
	props: ['questions', 'questionsType'],
	data() {
		return {
			listId: '',
			keyRender: 0,
		};
	},
	mounted() {
		this.listId = genId();
		setTimeout(() => {
			this.initSortable();
		});
	},
	methods: {
		propOr,
		pathOr,
		initSortable() {
			const table = document.getElementById(this.listId);
			this.$sortable = new Sortable(table, {
				handle: '.sort-handler', // handle's class
				animation: 150,
				onEnd: event => this.applySortChanges(event),
			});
		},
		applySortChanges({ oldIndex, newIndex }) {
			const updatedQuestions = move(oldIndex, newIndex, this.questions);
			this.$emit('onSortedQuestionsChange', updatedQuestions);
		},
	},
	watch: {
		questions: {
			handler() {
				this.keyRender = this.keyRender + 9;
			},
			deep: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.evaluation-questions-section--row__questions {
	list-style: none;
	padding: 0;
	li {
		border-bottom: 1px solid var(--app-color-gray);
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/third-step/components/evaluation-question-sortable-list.vue